import { PayloadAction } from '../../model/action.model';

export const PUSH_ERROR_MESSAGE = 'PUSH_ERROR_MESSAGE';
export const CLEAR_ERROR_MESSAGES = 'CLEAR_ERROR_MESSAGES';

export class PushError implements PayloadAction {
    readonly type = PUSH_ERROR_MESSAGE;
    constructor(public payload) { }
  }

  export class ClearAllErrors implements PayloadAction {
    readonly type = CLEAR_ERROR_MESSAGES;
    constructor(public payload?) { }
  }
  export type ErrorActions = PushError | ClearAllErrors;
